import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { getTestId, GridCol, GridRow } from '@airtel/air-design-system';
import { Children } from 'react';
import { View } from 'react-native';
import { getGridSectionStyles } from './GridSectionStyles';
export var GridSectionComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'GridSection' : _props$testID,
    style = props.style,
    children = props.children,
    numColumns = props.numColumns,
    rowStyle = props.rowStyle,
    rowProps = props.rowProps,
    columnStyle = props.columnStyle,
    columnProps = props.columnProps,
    _props$columnBreakpoi = props.columnBreakpoints,
    columnBreakpoints = _props$columnBreakpoi === void 0 ? {
      xs: 6
    } : _props$columnBreakpoi;
  var gridSectionStyles = getGridSectionStyles();
  var gridData = [];
  var widgetArray = Children.toArray(children);
  for (var i = 0; i < widgetArray.length; i += numColumns) {
    gridData.push(widgetArray.slice(i, i + numColumns));
  }
  return _jsx(View, Object.assign({}, getTestId(testID), {
    style: [style]
  }, {
    children: gridData.length > 0 && gridData.map((widgets, rowIndex) => {
      return _createElement(GridRow, Object.assign({}, rowProps, {
        key: "grid_row_" + rowIndex,
        style: [rowProps === null || rowProps === void 0 ? void 0 : rowProps.style, rowStyle]
      }), widgets.length > 0 && widgets.map((widget, colIndex) => {
        var _a;
        var breakpoints = Array.isArray(columnBreakpoints) ? (_a = columnBreakpoints[rowIndex]) === null || _a === void 0 ? void 0 : _a[colIndex] : columnBreakpoints;
        return _createElement(GridCol, Object.assign({}, columnProps, {
          style: [columnProps === null || columnProps === void 0 ? void 0 : columnProps.style, columnStyle, gridSectionStyles.column],
          breakpoints: breakpoints,
          key: "grid_col_" + rowIndex + "_" + colIndex
        }), widget);
      }));
    })
  }));
};
GridSectionComponent.genericRendererKey = 'AirGridSection';
GridSectionComponent.isAirSection = true;